<ng-container *ngIf="hideDialogWrapper; else withDialogWrapper">
	<ng-template [ngTemplateOutlet]="innerTemplate"></ng-template>
</ng-container>

<ng-template #withDialogWrapper>
	<obg-m-dialog-layout #dialog [titleText]="'forgot-password.title' | translate" [isLoading]="isBusy">
		<ng-template [ngTemplateOutlet]="innerTemplate"></ng-template>
	</obg-m-dialog-layout>
</ng-template>

<ng-template #innerTemplate>
	<ng-container *ngIf="fabricForgotPasswordComponent; else standardForgotPasswordComponent">
		<ng-container *ngIf="translations$ | async as translations">
			<account-forgot_password_v2
				[translations]="translations"
				(confirmationButtonClicked)="closeDialog()"
			></account-forgot_password_v2>
		</ng-container>
	</ng-container>

	<ng-template #standardForgotPasswordComponent>
		<obg-m-forgot-password-email-container
			*ngIf="!success; else successMessage"
			(success)="onSuccess()"
			(isBusy)="isBusy = $event"
		></obg-m-forgot-password-email-container>
	</ng-template>

	<ng-template #successMessage>
		<span class="circled-icon {{ forgotPasswordIcon }}"></span>
		<p [innerHtml]="'forgot-password.success-message' | translate" role="heading"></p>

		<div class="obg-m-lg-forgot-password-actions">
			<button
				mat-flat-button
				class="forgot-password-ok-btn"
				test-id="forgot-password-ok"
				data-test-id="forgot-password-ok"
				color="accent"
				(click)="closeDialog()"
			>
				{{ 'general.ok' | translate }}
			</button>
		</div>
	</ng-template>
</ng-template>
